// In-app route for /card/:uuid (e.g. opened from the dashboard).
// Visitors from NFC/QR/links get the standalone card page (card.html) served by the backend instead.
import { useParams } from 'react-router-dom';
import CardPage from '@/features/card/CardPage';

const Card = () => {
    const { uuid } = useParams();
    return <CardPage key={uuid} uuid={uuid} />;
};

export default Card;
